import React from "react";
import { Instagram, ArrowUpRight } from "lucide-react";
import { useContent } from "../context/ContentContext";
import { Reveal } from "./Reveal";

const InstagramSection = () => {
  const { content } = useContent();
  const handle = content?.settings?.instagramHandle || "curiousgeorge27";
  const hashtag = content?.settings?.hashtag || "#GeorgeAndAmy";

  return (
    <section className="py-24 md:py-32 bg-secondary/40" data-testid="instagram-section">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <Reveal>
          <Instagram size={36} className="text-dusty mx-auto mb-6" />
          <span className="uppercase tracking-[0.3em] text-xs text-dusty font-bold">Follow our journey</span>
          <h2 className="font-serif text-4xl md:text-5xl text-navy mt-4">Share your moments</h2>
          <p className="text-navy mt-5 max-w-xl mx-auto leading-relaxed">
            Follow along and tag your photos with <span className="font-bold text-navy">{hashtag}</span> so we can relive
            every moment through your eyes.
          </p>
          <a
            href={`https://instagram.com/${handle}`}
            target="_blank"
            rel="noreferrer"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-navy text-white px-8 py-4 uppercase tracking-[0.18em] text-sm hover:bg-dusty transition-colors duration-300"
            data-testid="instagram-follow-btn"
          >
            @{handle} <ArrowUpRight size={16} />
          </a>
        </Reveal>
      </div>
    </section>
  );
};

export default InstagramSection;
